

export class MaintenanceTypeOutputWithStatus implements IMaintenanceTypeOutputWithStatus {
    /** The auto-generated id of the maintenance master */
    maintenance_type_id!: number;
    /** The maintenance type name with 255 character limit */
    maintenance_type_name!: string;
    /** Manage status of maintenance type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IMaintenanceTypeOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maintenance_type_id = _data["maintenance_type_id"];
            this.maintenance_type_name = _data["maintenance_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MaintenanceTypeOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTypeOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenance_type_id"] = this.maintenance_type_id;
        data["maintenance_type_name"] = this.maintenance_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IMaintenanceTypeOutputWithStatus {
    /** The auto-generated id of the maintenance master */
    maintenance_type_id: number;
    /** The maintenance type name with 255 character limit */
    maintenance_type_name: string;
    /** Manage status of maintenance type. 0 For De-active, 1 For Active */
    status: number;
}

